import { render } from "./RegisterClient.vue?vue&type=template&id=0b746c41&scoped=true"
import script from "./RegisterClient.vue?vue&type=script&lang=js"
export * from "./RegisterClient.vue?vue&type=script&lang=js"

import "./RegisterClient.vue?vue&type=style&index=0&id=0b746c41&scoped=true&lang=css"

import exportComponent from "/mnt/extra-storage/greenbelt_garbage/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b746c41"]])

export default __exports__